<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-grid-beat" [fullScreen]="true">
    <p style="color: white">Please Wait...While Fetching Data</p>
</ngx-spinner>

<div class="header_second">
    <div class="Dashboard_head ">Event Type

        <div>
            <button mat-raised-button color="primary" style="font-size: 14px;
                    margin-right: 15px;" (click)="addtype()"><mat-icon>add</mat-icon>Add</button>
        </div>

    </div>
</div>


<div class="mat-elevation-z8" style="margin: 0.5rem;">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Search</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Search" #input>
    </mat-form-field>
    <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort>

            <!-- Position Column -->
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>ID.</th>
                <td mat-cell *matCellDef="let element"> {{element.id}} </td>
            </ng-container>

            <ng-container matColumnDef="event_type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Event Type </th>
                <td mat-cell *matCellDef="let element">{{element.event_type}}</td>
            </ng-container>

            <ng-container matColumnDef="created_date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Created Date </th>
                <td mat-cell *matCellDef="let element">{{element.created_date | date:'dd/MM/yyyy'}}</td>
            </ng-container>

            <ng-container matColumnDef="action" stickyEnd justify="end">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
                <td mat-cell *matCellDef="let element">
                    <button mat-raised-button color="primary" matTooltip="Edit" style="margin-right: 5px;"
                        (click)="Edit_type(element.id)">
                        <mat-icon class="m-0">edit</mat-icon>
                    </button>

                    <button mat-raised-button color="warn" matTooltip="Delete" (click)="Deletetype(element.id)">
                        <mat-icon class=" m-0">delete</mat-icon>
                    </button>

                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <mat-paginator [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons
        aria-label="Select page of periodic elements">
    </mat-paginator>
</div>